import React from 'react';
import { useSelector } from 'react-redux';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

const MIN = 0;
const MAX = 2500;

const BarIndicators = () => {
  const nodeDetails = useSelector((state) => state?.fuse?.dashboard?.nodeDetails?.generalInfo);
  // const normalise = (value) => ((value - MIN) * 100) / (MAX - MIN);

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: '30px',
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: '#EDF0F5',
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: '#95C574',
    }
  }));

  return (
    <div className="w-60 flex-grow mt-10" style={{ width: '100%' }}>
      <strong className="title-chart">Porcentaje de pérdida de paquetes</strong>
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '20px',
        }}
      >
        <div style={{ width: '70%' }}>
          {/* <strong>Avg Resp Time</strong>
          <BorderLinearProgress variant="determinate" value={normalise(1000)} />
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <p>0</p>
            <p>500</p>
            <p>1000</p>
            <p>1500</p>
            <p>2000</p>
            <p>2500</p>
          </div> */}

          <BorderLinearProgress variant="determinate" value={Number(nodeDetails?.porcenloss) || 0} />
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <p>0</p>
            <p>20</p>
            <p>40</p>
            <p>60</p>
            <p>80</p>
            <p>100</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BarIndicators
